export const D4_SHOOTING_DAMAGE_FOR_1_BUILDING_DAMAGE = 4;